import React from 'react';
import HelpPanel from '@cloudscape-design/components/help-panel';
import { ExternalLinkGroup } from './common';

export function EmailPreviewHelp() {
  return (
    <HelpPanel
      header={<h2>Email Preview</h2>}
      footer={
        <ExternalLinkGroup
          items={[
            { href: '#', text: 'Email Template Documentation' },
            { href: '#', text: 'Email Design Best Practices' },
            { href: '#', text: 'Email Tracking Guide' }
          ]}
        />
      }
    >
      <p>
        The Email Preview page allows you to view and test email templates used for customer notifications.
      </p>
      
      <h3>Email Templates</h3>
      <p>
        The system uses different templates for each notification type:
      </p>
      <ul>
        <li><strong>New Deployment</strong>: For customers deploying an AWS Solution for the first time</li>
        <li><strong>Multiple Solutions</strong>: For customers deploying multiple AWS Solutions</li>
        <li><strong>Repeat Deployment</strong>: For customers deploying another instance of a solution they've used before</li>
        <li><strong>Long Term</strong>: For customers keeping a deployment active for an extended period (6+ months)</li>
      </ul>
      
      <h3>Template Actions</h3>
      <p>
        For each template, you can:
      </p>
      <ul>
        <li><strong>Preview</strong>: Generate a preview of the email with custom data</li>
        <li><strong>Send Test</strong>: Send a test email to your development email address</li>
      </ul>
      
      <h3>Preview Modal</h3>
      <p>
        When previewing a template, you can customize the following variables:
      </p>
      <ul>
        <li><strong>Customer Name</strong>: The name of the customer</li>
        <li><strong>Account Manager Name</strong>: The name of the account manager</li>
        <li><strong>Solution Name</strong>: The AWS Solution being deployed</li>
        <li><strong>AWS Account ID</strong>: The customer's AWS account ID</li>
      </ul>
      
      <h3>Template Variables</h3>
      <p>
        Email templates use variables that are replaced with actual data when an email is sent:
      </p>
      <ul>
        <li><strong>{"{{customerName}}"}</strong>: The customer's name</li>
        <li><strong>{"{{accountManagerName}}"}</strong>: The recipient's name</li>
        <li><strong>{"{{solutionName}}"}</strong>: The AWS Solution name</li>
        <li><strong>{"{{creationDate}}"}</strong>: When the solution was deployed</li>
        <li><strong>{"{{awsAccountId}}"}</strong>: The AWS account ID</li>
        <li><strong>{"{{trackingLink}}"}</strong>: Link for click tracking</li>
        <li><strong>{"{{openTrackingPixel}}"}</strong>: Pixel for open tracking</li>
      </ul>
      
      <h3>Email Structure</h3>
      <p>
        All email templates follow a consistent structure:
      </p>
      <ul>
        <li><strong>Header</strong>: AWS Solutions Library branding</li>
        <li><strong>Subject</strong>: Customer name and notification type</li>
        <li><strong>Message</strong>: Main notification content</li>
        <li><strong>Deployment Details</strong>: Table with solution information</li>
        <li><strong>Call to Action</strong>: Button linking to more details</li>
        <li><strong>Signature</strong>: Standard closing and contact information</li>
        <li><strong>Footer</strong>: Legal information and disclaimers</li>
      </ul>
      
      <h3>Send History</h3>
      <p>
        The Send History tab shows a record of test emails that have been sent, including:
      </p>
      <ul>
        <li>Template used</li>
        <li>Recipient</li>
        <li>Send date and time</li>
        <li>Delivery status</li>
      </ul>
    </HelpPanel>
  );
}
